import * as React from 'react';
import classNames from 'utils/classNames';
import './tileHeader.css';
import KebobMenu from 'molecules/kebobMenu';

export interface TileInterface {
  /**
   * children nodes that form body and footer of tile
   */
  children?: string | React.ReactNode | React.ReactNodeArray;
  /**
   * string value used in p tag
   */
  description?: string | React.ReactNode | React.ReactNodeArray;
  /**
   * optional prop, if passed, will add text next to title. example: `Step 2 of 2`
   */
  progress?: string;
  /**
   * if true, will truncate the heading. Defaults to true
   */
  shouldTruncate?: boolean;
  /**
   * inline styles applied to root
   */
  style?: React.CSSProperties;
  /**
   * string value used in tile header
   */
  title?: string;
  /**
   * if specified, will render a kebob button on the right side
   * that collapses to a menu with provided elements
   */
  kebobMenuItems?: () => JSX.Element;

  /**
   * if specified, will render elements in a horizontal row next to the header title
   */
  headerChildren?: JSX.Element | JSX.Element[];
}

const TileHeader: React.StatelessComponent<TileInterface> = ({
  children,
  description,
  progress,
  style = {},
  title,
  shouldTruncate = true,
  kebobMenuItems,
  headerChildren,
}): JSX.Element => {
  return (
    <div
      className="tileHeaderContainer"
      style={{ gridColumnGap: children ? 12 : 0, ...style }}
    >
      {title || progress ? (
        <div
          className={classNames({
            tileHeaderTileWrapper: true,
            tileHeaderHasKebab: !!kebobMenuItems,
          })}
        >
          {title && (
            <h1
              className={classNames({
                shouldTruncate,
              })}
            >
              {title}
            </h1>
          )}
          {kebobMenuItems && (
            <KebobMenu
              children={kebobMenuItems()} // eslint-disable-line
              offsets={{
                left: -60,
              }}
            />
          )}
          {progress ? (
            <div className="tileHeaderProgress">{progress}</div>
          ) : null}

          {headerChildren}
        </div>
      ) : null}
      {description && (
        <div data-ref="tileHeaderDescription" className="tileHeaderDescription">
          {description}
        </div>
      )}
      {children ? children : null}
    </div>
  );
};

export default TileHeader;
